import * as React from 'react';
import { SVGProps } from 'react';

const SvgCopyLink = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m12.05 13.021-.707-.707-1.414 1.414.707.707 1.415-1.414Zm.708-7.778a1 1 0 0 0 1.414 1.414l-1.414-1.414Zm-2.122 9.192.707.707 1.415-1.414-.707-.707-1.415 1.414Zm4.95.707 4.596-4.596-1.414-1.414-4.596 4.596 1.414 1.414Zm-1.768-10.96-1.06 1.06 1.414 1.415 1.06-1.06-1.414-1.415Zm6.364 0a4.5 4.5 0 0 0-6.364 0l1.415 1.414a2.5 2.5 0 0 1 3.535 0l1.414-1.414Zm0 6.364a4.5 4.5 0 0 0 0-6.364l-1.414 1.414a2.5 2.5 0 0 1 0 3.536l1.414 1.414Zm-8.839 4.596a3 3 0 0 0 4.243 0l-1.414-1.414a1 1 0 0 1-1.414 0l-1.415 1.414ZM12.758 10.899l.707.707 1.414-1.415-.707-.707-1.414 1.415Zm-.707 7.778a1 1 0 0 0-1.415-1.414l1.415 1.414Zm2.121-9.193-.707-.707-1.414 1.415.707.707 1.414-1.415Zm-4.95-.707-4.596 4.597 1.414 1.414 4.596-4.597-1.414-1.414Zm1.768 10.96 1.06-1.06-1.414-1.414-1.06 1.06 1.414 1.415Zm-6.364 0a4.5 4.5 0 0 0 6.364 0l-1.414-1.414a2.5 2.5 0 0 1-3.536 0l-1.414 1.415Zm0-6.363a4.5 4.5 0 0 0 0 6.364l1.414-1.415a2.5 2.5 0 0 1 0-3.535l-1.414-1.415Zm8.839-4.597a3 3 0 0 0-4.243 0l1.415 1.415a1 1 0 0 1 1.414 0l1.414-1.415Z"
      fill="#fff"
    />
  </svg>
);
export default SvgCopyLink;
